module.exports = __webpack_public_path__ + "img/zoiper.ab318291.png";